import { Navigate, useParams } from 'react-router-dom'
import { useStores } from 'hooks'

/**
 * Redirect the old Ad Accounts route
 * (`/workspace/:accountId/asset/:assetId/ppc-accounts`) to the new
 * Settings › Connections page (Ad accounts tab). Preserves bookmarks/deep links.
 */
export const AdAccountsRedirect = () => {
	const { accountId, assetId } = useParams<{
		accountId: string
		assetId: string
	}>()
	if (!accountId || !assetId) return null
	return (
		<Navigate
			to={`/settings/workspace/${accountId}/asset/${assetId}/connections?tab=ad-accounts`}
			replace
		/>
	)
}

/**
 * Redirect the old Authorizations route (`/workspace/:accountId/connections`)
 * to the new Settings › Connections page (Credentials tab). The old route is
 * not asset-scoped, so the current asset is taken from the store.
 */
export const AuthorizationsRedirect = () => {
	const { accountId } = useParams<{ accountId: string }>()
	const {
		assetStore: { asset }
	} = useStores()
	if (!accountId || !asset?.id) return null
	return (
		<Navigate
			to={`/settings/workspace/${accountId}/asset/${asset.id}/connections?tab=credentials`}
			replace
		/>
	)
}
